// extracted by mini-css-extract-plugin
export var truncate = "_w-0";